// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.VerifiableContactDetailField-module__formInput___33xjF{flex:0 0 auto}", ""]);
// Exports
exports.locals = {
	"formInput": "VerifiableContactDetailField-module__formInput___33xjF"
};
module.exports = exports;
